import React from "react";
import useSWR from "swr";
import ShieldDefect from "../../assets/escudo_defecto.jpg";
import { useParams, useLocation } from "react-router";
import { URL_BASE_API } from "../utilities.js/endpoints";
import Overlay from "../Overlay/Overlay";
import CountdownTimer from "../CoutDownTimer/CountDownTime";
import { fetcher } from "../utilities.js/fetcherUtil";
import { getUserCountry } from "../utilities.js/timeZone";
// import data from "./static.json";
import mockData from "./static.json";

import { LANGUAGE_HOMOLOGATION_CODE } from "../utilities.js/codes";

const stageIncludeTime = ["1T", "2T", "A1", "A2"];

const matchInterruptionTypes = {
  'Cancelled': 'CC',
  'Postponed': 'PP',
  'Suspended': 'SP'
}

const matchStatusLabels = {
  'FIN': 'FINALIZADO',
  'CC': 'CANCELADO',
  'SP': 'SUSPENDIDO',
  'PP': 'POSTERGADO',
}

const Static = ({ useMock = false }) => {
  const {
    tournamentId = useMock ? 'a81lq2nnsh2h11qr4z5cpieei' : '',
    seasonId,
    matchId
  } = useParams();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const sponsorImgURL = queryParams.get("sponsorURL");
  const matchURL = `${URL_BASE_API}/fixtures/${tournamentId}/${seasonId}/${matchId}.json`;
  const userCountry = getUserCountry();

  const { data = {} } = useSWR(
    [
      matchURL,
    ],
    fetcher,
    { refreshInterval: 30000 }
  );

  const dataObject = useMock ? mockData : data;

  const {
    matchInfo: { contestant: teams = [], date, time, competition } = {},
    liveData: { matchDetails } = {},
  } = dataObject;

  const getPenalties = (position) => matchDetails?.scores?.pen?.[position];

  const getResults = (position) => (matchDetails?.scores?.total?.[position] ?? 0) - (matchDetails?.scores?.pen?.[position] ?? 0);

  const getStage = () => {
    // 1 (First half)
    // 2 (Second half)
    // 3 (Extra time - first half)
    // 4 (Extra time - second half)
    // 5 (Penalty shootout)
    // 10 (Half time)
    // 11 (End of second half - before extra time)
    // 12 (Extra time - half time)
    // 13 (End of extra time - before penalties)
    // 14 (Full time)
    // 16 (Pre-match)

    const matchStatusOnly = matchDetails?.matchStatus;
    if (!matchDetails?.periodId
      || matchStatusOnly === "Cancelled"
      || matchStatusOnly === "Postponed"
      || matchStatusOnly === "Suspended"
    ) return matchInterruptionTypes[matchDetails?.matchStatus] || 'CC';

    switch (matchDetails?.periodId) {
      case 1:
        return "1T";
      case 2:
        return "2T";
      case 3:
        return "A1";
      case 4:
        return "A2";
      case 5:
        return "PEN";
      case 10:
        return "ET";
      case 11:
        return "FTR";
      case 12:
        return "FA1";
      case 13:
        return "FA2";
      case 14:
        return "FIN";
      // case 16:
      //   return "F";

      default:
        return "F";
    }
  };

  const getId = (team) => {
    const ids = [
      '59tpnfrwnvhnhzmnvfyug68hj', // Libertadores
      '32n2r9bl6x90psj0wa7bfs6vq', // Sudamericana
      'bdtat25m14jy85y484z3e6lf', // Copa Argentina
      '581t4mywybx21wcpmpykhyzr3', // Liga Profesional Argentina
      'byu00jvt1j6csyv4y1lkt2fm2', // Argentina Primera Nacional
    ]
    if (ids.includes(data.matchInfo.competition.id)) {
      return `-${team.id}`
    }

    return '';
  }

  const getLastSuspensionFormattedTime = () => {
    if (stage === 'FIN' || stage === 'CC' || stage === 'PP') return null;

    const periods = matchDetails?.period || [];
    if (!Array.isArray(periods) || periods.length === 0) return null;

    let lastSuspension = null;
    let periodStart = null;
    let periodId = null;

    for (const period of periods) {
      const suspensions = period?.suspension;
      if (!Array.isArray(suspensions) || suspensions.length === 0) continue;

      for (const suspension of suspensions) {
        if (suspension?.start) {
          lastSuspension = suspension.start;
          periodStart = period?.start;
          periodId = period?.id;
        }
      }
    }

    if (!lastSuspension || !periodStart || !periodId) return null;

    // Calcular diferencia en milisegundos
    const suspensionTime = new Date(lastSuspension).getTime();
    const periodStartTime = new Date(periodStart).getTime();
    const diffMs = suspensionTime - periodStartTime;

    if (diffMs < 0) return null;

    const totalSeconds = Math.floor(diffMs / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    const paddedSeconds = seconds.toString().padStart(2, '0');

    // Mapear ID a texto
    const periodLabelMap = {
      1: '1T',
      2: '2T',
      3: 'ET1',
      4: 'ET2'
    };

    const periodLabel = periodLabelMap[periodId] || `P${periodId}`;
    return <span>{`${periodLabel} | ${minutes}:${paddedSeconds}`}</span>
  };

  const getCountryName = (name) => name.replace(/ /g, "-").replace(/\//g, "-").toLowerCase();

  const flagLocal = teams && teams.find(team => team.position === 'home')?.flagUrl;
  const flagAway = teams && teams.find(team => team.position === 'away')?.flagUrl;

  const teamShieldRight = competition?.country?.name ? flagLocal || `${URL_BASE_API}/escudos/${getCountryName(competition.country.name)}/${teams[0].code}${getId(teams[0])}.svg` : ShieldDefect;
  const teamShieldLeft = competition?.country?.name ? flagAway || `${URL_BASE_API}/escudos/${getCountryName(competition.country.name)}/${teams[1].code}${getId(teams[1])}.svg` : ShieldDefect;
  const teamNamedRight = teams?.[0]?.code ? LANGUAGE_HOMOLOGATION_CODE[teams?.[0]?.code] || teams?.[0]?.code : "";
  const teamNamedLeft = teams?.[1]?.code ? LANGUAGE_HOMOLOGATION_CODE[teams?.[1]?.code] || teams?.[1]?.code : "";
  const teamPenaltyRight = getPenalties(teams?.[0]?.position);
  const teamPenaltyLeft = getPenalties(teams?.[1]?.position);
  const teamGoalsRight = getResults(teams?.[0]?.position);
  const teamGoalsLeft = getResults(teams?.[1]?.position);
  const stage = getStage();

  const getStatusLabel = (matchStageCode) => matchStatusLabels[matchStageCode] || matchStageCode;
  const getShortStageMatch = () => {
    if (stage === "F") return null;
    const stageText = getStatusLabel(stage);
    const isMatchInterrupted = stage === 'SP' || stage === 'CC' || stage === 'PP' || stage === 'FIN';
    const labelTimeSuspendOrCancel = getLastSuspensionFormattedTime();


    return <>
      <p className="state-match" style={{
        fontWeight: isMatchInterrupted ? "300" : ""
      }}> {stageText}</p>
      {labelTimeSuspendOrCancel}
    </>
  };

  if (!dataObject.matchInfo) {
    return <Overlay />;
  }

  const getMatchDetails = () => {
    if (stage === "F") return null;

    const getMatchAccountant = () => {
      if (stage === 'PP' || stage === 'CC') return null;
      return (
        <div className="match-accountant">
          <p className="goals">
            {teamPenaltyRight !== undefined ? (
              <p className="penalty-goals">({teamPenaltyRight})</p>
            ) : null}
            {teamGoalsRight}
          </p>
          <span className="progress-time" />
          <p className="goals">
            {teamGoalsLeft}
            {teamPenaltyLeft !== undefined ? (
              <p className="penalty-goals">({teamPenaltyLeft})</p>
            ) : null}
          </p>
        </div>
      )
    }
    const matchSuspend = stage === 'SP' ? 'match-suspend' : ''
    return (
      <div className="match-details-ctn">
        <div className={`match-time ${matchSuspend}`}>
          {getShortStageMatch()}
          {stageIncludeTime.includes(stage) && (
            <>
              <span className="match-time-divisor" />
              <CountdownTimer
                matchStatus={stage}
                firstPeriod={matchDetails?.period?.filter(x => x.id === 1)?.[0]}
                secondPeriod={matchDetails?.period?.filter(x => x.id === 2)?.[0]}
                thirdPeriod={matchDetails?.period?.filter(x => x.id === 3)?.[0]}
                fourthPeriod={matchDetails?.period?.filter(x => x.id === 4)?.[0]}
              />
            </>
          )}
        </div>
        {getMatchAccountant()}
      </div>
    );
  };

  const getLabelPostponedOrCancelled = (matchStartTime) => {
    if (!stage) return null;
    return (
      <div className="match-start-time-ctn">
        <p className="match-start-time">{matchStatusLabels[stage]}</p>
        <p className="match-start-time">{matchStartTime}</p>
      </div>
    );
  }

  const getMatchStartTime = () => {
    if (stage !== "F") return null;

    if (!date || !time) {
      return (
        <div className="match-start-time-ctn">
          <p className="match-start-time">Próximamente</p>
        </div>
      )
    }

    const getFormattedTime = (_time = "") => {
      if (!_time) return null;

      const dateObject = new Date(_time);

      const localHour = dateObject.getHours();
      const localMinutes = dateObject.getMinutes();

      const formattedTime = `${localHour}:${localMinutes < 10 ? "0" : ""}${localMinutes} HS`;

      return formattedTime;
    };
    const matchStartTime = getFormattedTime(`${date?.replace("Z", "T")}${time}`);

    if (stage === "CC" || stage === "PP" || stage === "SP") return getLabelPostponedOrCancelled(matchStartTime);


    return (
      <div className="match-start-time-ctn">
        <p className="match-start-time">{matchStartTime}</p>
      </div>
    );
  };

  const getMatchBoard = () => (
    <div className="match-board">
      {getMatchDetails()}
      {getMatchStartTime()}
    </div>
  );
  
  const isBetano = sponsorImgURL === 'https://www.infobae.com/new-resizer/NAEgT0Vz6eSAb-hYbLZK1R6mWXs=/arc-anglerfish-arc2-prod-infobae/public/57UPQRSJW5FUZIFVMNMJ74RMY4.png';

  const getSponsorClass = () => {
    if (!sponsorImgURL) return "";
    return " with-sponsor-img-extra-padding";
  };

  const showSponsor = () => {
    if (!sponsorImgURL) return false;
    if (isBetano && userCountry !== 'Argentina') return false;

    return true;
  }

  return (
    <div className="container-static">
      {sponsorImgURL && (
        <div className="container-sponsor">
          {showSponsor() && <img src={sponsorImgURL} alt="Sponsor Logo" className="sponsor-img" />}
        </div>
      )}
      <div className={`container-preview-static${getSponsorClass()}`}>
        <div className="shield-team-left">
          <div className="name-team">{teamNamedRight}</div>
          <img src={teamShieldRight} alt="" className="shield" />
        </div>
        {getMatchBoard()}
        <div className="shield-team-right">
          <img src={teamShieldLeft} alt="" className="shield" />
          <div className="name-team">{teamNamedLeft}</div>
        </div>
      </div>
    </div>
  );
};

export default Static;
